import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=4771e8ef&lang=scss&scoped=true"
script.__scopeId = "data-v-4771e8ef"

export default script